import helper from '../helper';

export default {
	state: {
		setDisplayName: {
			loading: false,
		},
	},
	mutations: {
		requestDisplay(state) {
			state.setDisplayName.loading = true;
		},
		finishRequestDisplay(state) {
			state.setDisplayName.loading = false;
		},
	},
	actions: {
		async setDisplay({ commit }, params) {
			return helper(this, async () => {
				commit('requestDisplay');
				await axf.api('commonRequest', {
					...params,
					url: '/axinsf/sfxm/setCfjfAndKhdJf',
				});
				commit('finishRequestDisplay');
			});
		},
	},
};
